import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderOneDriveCommon = {
  key: 'oneDrive',
  authentication: ProviderAuthenticationCommon.Oauth2({
    key: 'oneDrive',
    authUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/authorize`,
    tokenUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/token`,
    scopes: [
      'https://graph.microsoft.com/Files.ReadWrite.All',
      'https://graph.microsoft.com/User.Read',
      'offline_access',
    ],
  }),
}

export type ProviderOneDriveAccountType = {
  email?: string
}

export enum Extensions {
  XLSX = '.xlsx',
  XLS = '.xls',
  PDF = '.pdf',
  DOCX = '.docx',
  DOC = '.doc',
  CSV = '.csv',
  MSG = '.msg',
  PNG = '.png',
  JPEG = '.jpeg',
  JPG = '.jpg',
}

export enum MimeTypes {
  FOLDER = 'application/vnd.google-apps.folder',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
  PDF = 'application/pdf',
  MSG = 'application/vnd.ms-outlook',
  PNG = 'image/png',
  JPEG = 'image/jpeg',
}

export type FileType = {
  id: string
  content?: string
  filepath?: string
  size?: number
  name: string
  mimeType: MimeTypes
  modifiedTime?: string
  folderId?: string
}
